module.exports = __webpack_public_path__ + "static/media/audio_signal.b8278d42.png";